<template>
  <v-container class="pa-0 ma-0 industry-page">
    <h1 class="show-title mb-10">Find your research partner</h1>
    <!--
    <h1 class="d-lg-none show-title mb-10">{{ content.title }}</h1>
    <p class="industry-text">{{ content.text1 }}</p>
    -->
    <div class="industry-text">
      <p>
        If you are a company interested in developing a collaborative project
        with NOVA researchers, reach out to us through this form specifying your
        needs.
      </p>
      <p>
        We will liaise with our research units to find the best match for you
        and we will support drafting the collaborative agreement, as needed.
      </p>

      <ContactForm />
    </div>
  </v-container>
</template>

<script>
import ContactForm from '@/components/ContactForm'

export default {
  name: 'FindYourResearchPartner',
  components: {
    ContactForm,
  },
  props: {
    content: {
      type: Object,
      required: true,
    },
  },
}
</script>

<style></style>
